import { cn } from '@/lib/utils';
import { shellT } from '@/i18n/messages/shell';

export function Spinner({ className }: { className?: string }) {
  return (
    <span
      className={cn('inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent', className)}
      aria-label={shellT().spinnerLabel}
    />
  );
}
